<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span>{{ 'Chairs' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography py-0 mt-4">
  <div class="d-flex justify-content-start justify-content-between">
    <div class="col-md-6 col-2">
      <app-frontend-input [(value)]="title"
                          [required]="true"
                          [title]="'Title'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-2 mx-lg-5">
      <app-frontend-button (click)="onCreateClicked()"
                           [Image]="true"
                           [class]="'card-main'"
                           [endpoint]="ServicePath.CREATE_SPACES"
                           [src]="'icons/add2.svg'"
                           [title]="'Insert'">
      </app-frontend-button>
    </div>
  </div>
  <div class="card-body-table">
    <app-frontend-table [dataSource]="spaces"
                        [displayColumnEndpoints]="displayEndPoint"
                        [displayColumnTypes]="displayColumnTypes"
                        [displayColumns]="displayedColumns"
                        [displayDataSources]="displayDataSources"
                        [hasPagination]="false"
                        [tableProperties]="tableProperties">
    </app-frontend-table>
  </div>
</mat-dialog-content>
